/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import { ApiContentPage, ApiContentPageFromJSON, ApiContentPageToJSON } from '../models';

export interface GetGeneralPageRequest {
  generalType: string;
  selectionKey?: string;
  shouldBeVerbose?: boolean;
  shouldExplain?: boolean;
  zoneRangeFrom?: number;
  zoneRangeTo?: number;
  chewyInsights?: string;
  deviceId?: string;
  chewyOverridesContentPreview?: string;
  ticket?: string;
  xChewyAuthIdToken?: string;
  xChewyInternal?: string;
  xChewyVisitorContext?: string;
  commercePersonalizationId?: string;
  xPersonalizationID?: string;
  xRequestID?: string;
}

export interface GetPageRequest {
  pageType: string;
  shouldBeVerbose?: boolean;
  shouldExplain?: boolean;
  zoneRangeFrom?: number;
  zoneRangeTo?: number;
  partNumbers?: string;
  categoryId?: number;
  salesCategoryId?: number;
  facetMapping?: string;
  searchTerms?: string;
  chewyInsights?: string;
  deviceId?: string;
  chewyOverridesContentPreview?: string;
  ticket?: string;
  xChewyAuthIdToken?: string;
  xChewyInternal?: string;
  xChewyVisitorContext?: string;
  commercePersonalizationId?: string;
  xPersonalizationID?: string;
  xRequestID?: string;
}

/**
 *
 */
export class ContentApi extends runtime.BaseAPI {
  /**
   * Fetch content for general page types
   */
  async getGeneralPageRaw(
    requestParameters: GetGeneralPageRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiContentPage>> {
    if (requestParameters.generalType === null || requestParameters.generalType === undefined) {
      throw new runtime.RequiredError(
        'generalType',
        'Required parameter requestParameters.generalType was null or undefined when calling getGeneralPage.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.selectionKey !== undefined) {
      queryParameters['selectionKey'] = requestParameters.selectionKey;
    }

    if (requestParameters.shouldBeVerbose !== undefined) {
      queryParameters['shouldBeVerbose'] = requestParameters.shouldBeVerbose;
    }

    if (requestParameters.shouldExplain !== undefined) {
      queryParameters['shouldExplain'] = requestParameters.shouldExplain;
    }

    if (requestParameters.zoneRangeFrom !== undefined) {
      queryParameters['zoneRangeFrom'] = requestParameters.zoneRangeFrom;
    }

    if (requestParameters.zoneRangeTo !== undefined) {
      queryParameters['zoneRangeTo'] = requestParameters.zoneRangeTo;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIdToken !== undefined &&
      requestParameters.xChewyAuthIdToken !== null
    ) {
      headerParameters['X-Chewy-Auth-Id-Token'] = String(requestParameters.xChewyAuthIdToken);
    }

    if (
      requestParameters.xChewyInternal !== undefined &&
      requestParameters.xChewyInternal !== null
    ) {
      headerParameters['X-Chewy-Internal'] = String(requestParameters.xChewyInternal);
    }

    if (
      requestParameters.xChewyVisitorContext !== undefined &&
      requestParameters.xChewyVisitorContext !== null
    ) {
      headerParameters['X-Chewy-Visitor-Context'] = String(requestParameters.xChewyVisitorContext);
    }

    if (
      requestParameters.commercePersonalizationId !== undefined &&
      requestParameters.commercePersonalizationId !== null
    ) {
      headerParameters['Commerce-PersonalizationId'] = String(
        requestParameters.commercePersonalizationId,
      );
    }

    if (
      requestParameters.xPersonalizationID !== undefined &&
      requestParameters.xPersonalizationID !== null
    ) {
      headerParameters['X-Personalization-ID'] = String(requestParameters.xPersonalizationID);
    }

    if (requestParameters.xRequestID !== undefined && requestParameters.xRequestID !== null) {
      headerParameters['X-Request-ID'] = String(requestParameters.xRequestID);
    }

    const response = await this.request(
      {
        path: `/v1/pages/general/types/{generalType}`.replace(
          `{${'generalType'}}`,
          encodeURIComponent(String(requestParameters.generalType)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => {
      console.log(jsonValue);
      return ApiContentPageFromJSON(jsonValue);
    });
  }

  /**
   * Fetch content for general page types
   */
  async getGeneralPage(
    requestParameters: GetGeneralPageRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiContentPage> {
    const response = await this.getGeneralPageRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Fetch content by page type. Supported page types : plp, pdp, header, hp, nma-home, nma-health-v2
   */
  async getPageRaw(
    requestParameters: GetPageRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<runtime.ApiResponse<ApiContentPage>> {
    if (requestParameters.pageType === null || requestParameters.pageType === undefined) {
      throw new runtime.RequiredError(
        'pageType',
        'Required parameter requestParameters.pageType was null or undefined when calling getPage.',
      );
    }

    const queryParameters: any = {};

    if (requestParameters.shouldBeVerbose !== undefined) {
      queryParameters['shouldBeVerbose'] = requestParameters.shouldBeVerbose;
    }

    if (requestParameters.shouldExplain !== undefined) {
      queryParameters['shouldExplain'] = requestParameters.shouldExplain;
    }

    if (requestParameters.zoneRangeFrom !== undefined) {
      queryParameters['zoneRangeFrom'] = requestParameters.zoneRangeFrom;
    }

    if (requestParameters.zoneRangeTo !== undefined) {
      queryParameters['zoneRangeTo'] = requestParameters.zoneRangeTo;
    }

    if (requestParameters.partNumbers !== undefined) {
      queryParameters['partNumbers'] = requestParameters.partNumbers;
    }

    if (requestParameters.categoryId !== undefined) {
      queryParameters['categoryId'] = requestParameters.categoryId;
    }

    if (requestParameters.salesCategoryId !== undefined) {
      queryParameters['salesCategoryId'] = requestParameters.salesCategoryId;
    }

    if (requestParameters.facetMapping !== undefined) {
      queryParameters['facetMapping'] = requestParameters.facetMapping;
    }

    if (requestParameters.searchTerms !== undefined) {
      queryParameters['searchTerms'] = requestParameters.searchTerms;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.xChewyAuthIdToken !== undefined &&
      requestParameters.xChewyAuthIdToken !== null
    ) {
      headerParameters['X-Chewy-Auth-Id-Token'] = String(requestParameters.xChewyAuthIdToken);
    }

    if (
      requestParameters.xChewyInternal !== undefined &&
      requestParameters.xChewyInternal !== null
    ) {
      headerParameters['X-Chewy-Internal'] = String(requestParameters.xChewyInternal);
    }

    if (
      requestParameters.xChewyVisitorContext !== undefined &&
      requestParameters.xChewyVisitorContext !== null
    ) {
      headerParameters['X-Chewy-Visitor-Context'] = String(requestParameters.xChewyVisitorContext);
    }

    if (
      requestParameters.commercePersonalizationId !== undefined &&
      requestParameters.commercePersonalizationId !== null
    ) {
      headerParameters['Commerce-PersonalizationId'] = String(
        requestParameters.commercePersonalizationId,
      );
    }

    if (
      requestParameters.xPersonalizationID !== undefined &&
      requestParameters.xPersonalizationID !== null
    ) {
      headerParameters['X-Personalization-ID'] = String(requestParameters.xPersonalizationID);
    }

    if (requestParameters.xRequestID !== undefined && requestParameters.xRequestID !== null) {
      headerParameters['X-Request-ID'] = String(requestParameters.xRequestID);
    }

    const response = await this.request(
      {
        path: `/v1/pages/{pageType}`.replace(
          `{${'pageType'}}`,
          encodeURIComponent(String(requestParameters.pageType)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiContentPageFromJSON(jsonValue));
  }

  /**
   * Fetch content by page type. Supported page types : plp, pdp, header, hp, nma-home, nma-health-v2
   */
  async getPage(
    requestParameters: GetPageRequest,
    initOverrides?: RequestInit | runtime.InitOverideFunction,
  ): Promise<ApiContentPage> {
    const response = await this.getPageRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
